<div class="profile-page">
  <h1 class="page-title">{{ titleText }}</h1>

  <!-- Шапка: кто вошёл и выход -->
  <section class="card profile-hero" *ngIf="user">
    <span class="avatar">{{ initials }}</span>
    <div class="profile-hero__who">
      <strong>{{ displayName || user.phone || '—' }}</strong>
      <span class="profile-hero__meta">
        <span class="role-badge">{{ getRoleName() }}</span>
        <span class="muted">{{ isPublicClient ? user.phone : user.email }}</span>
      </span>
    </div>
    <button type="button" class="btn btn--ghost" (click)="logout()">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4M10 16l4-4-4-4M14 12H3"/></svg>
      {{ logoutTitle }}
    </button>
  </section>

  <!-- Вкладки -->
  <nav class="tabs" role="tablist">
    <button type="button" role="tab" class="tab" [class.active]="activeTab === 'profile'" [attr.aria-selected]="activeTab === 'profile'" (click)="switchTab('profile')">
      {{ profileTabText }}
    </button>
    <button type="button" role="tab" class="tab" [class.active]="activeTab === 'legal'" [attr.aria-selected]="activeTab === 'legal'" (click)="switchTab('legal')">
      {{ legalDetailsTabText }}
    </button>
  </nav>

  <!-- Вкладка «Профиль» -->
  <div *ngIf="activeTab === 'profile'">
    <div *ngIf="loading" class="loading">{{ loadingText }}</div>
    <div *ngIf="error" class="error-message">{{ error }}</div>

    <ng-container *ngIf="!loading && !error && user">
      <div class="cards-grid">
        <section class="card">
          <h2>{{ personalInfoText }}</h2>
          <dl class="details">
            <!-- Клиент по телефону: «Имя» вместо «ФИО», email у него служебный (совпадает с телефоном) — не показываем -->
            <div><dt>{{ isPublicClient ? nameText : fullNameText }}</dt><dd>{{ displayName || '—' }}</dd></div>
            <div *ngIf="!isPublicClient"><dt>{{ emailText }}</dt><dd>{{ user.email || '—' }}</dd></div>
            <div><dt>{{ phoneText }}</dt><dd>{{ user.phone || '—' }}</dd></div>
            <div><dt>{{ roleText }}</dt><dd>{{ getRoleName() }}</dd></div>
          </dl>
        </section>

        <section class="card">
          <h2>{{ companyInfoText }}</h2>
          <dl class="details">
            <div><dt>{{ companyNameText }}</dt><dd>{{ user.companyName || '—' }}</dd></div>
            <div><dt>{{ countryText }}</dt><dd>{{ getCountryName() }}</dd></div>
            <div><dt>{{ createdAtText }}</dt><dd>{{ formatDate(user.createdAt) }}</dd></div>
            <div *ngIf="user.comment" class="details__wide"><dt>{{ commentText }}</dt><dd>{{ user.comment }}</dd></div>
          </dl>
        </section>
      </div>

      <!-- Удаление аккаунта — мелкой ссылкой внизу: найдёт тот, кто ищет; предупреждение — в окне подтверждения -->
      <div class="account-delete">
        <button type="button" class="account-delete__link" (click)="openDeleteModal()">{{ deleteAccountButtonText }}</button>
      </div>
    </ng-container>
  </div>

  <!-- Вкладка «Реквизиты» -->
  <div *ngIf="activeTab === 'legal'">
    <section class="card">
      <div *ngIf="loadingRequisites" class="loading">{{ loadingText }}</div>

      <!-- Просмотр -->
      <ng-container *ngIf="!isEditingRequisites">
        <div *ngIf="!loadingRequisites && requisitesError" class="error-message">{{ requisitesError }}</div>
        <div *ngIf="!loadingRequisites && !requisites" class="empty-state">
          <p>{{ noRequisitesText }}</p>
          <button type="button" (click)="startEditingRequisites()" class="btn btn--primary">{{ fillRequisitesText }}</button>
        </div>

        <ng-container *ngIf="!loadingRequisites && requisites">
          <div class="card-head">
            <h2>{{ legalDetailsTabText }}</h2>
            <button type="button" (click)="startEditingRequisites()" class="btn btn--ghost">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20h4L19 9l-4-4L4 16v4zM14 6l4 4"/></svg>
              {{ editText }}
            </button>
          </div>
          <div *ngIf="requisitesSuccess" class="success-message">{{ successText }}</div>
          <app-view-requisites [requisites]="requisites" [loading]="loadingRequisites"></app-view-requisites>
        </ng-container>
      </ng-container>

      <!-- Редактирование -->
      <form *ngIf="!loadingRequisites && isEditingRequisites" [formGroup]="requisitesForm" (ngSubmit)="saveRequisites()" class="req-form">
        <div class="form-section">
          <div class="form-row">
            <div class="form-group">
              <label>{{ binText }}</label>
              <input type="text" formControlName="bin" class="form-control" maxlength="12" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group full-width">
              <label>{{ legalAddressText }}</label>
              <textarea formControlName="legalAddress" class="form-control" rows="2"></textarea>
            </div>
          </div>
        </div>

        <div class="form-section">
          <h3>{{ bankNameText }}</h3>
          <div class="form-row">
            <div class="form-group">
              <label>{{ bankNameText }}</label>
              <input type="text" formControlName="bankName" class="form-control" />
            </div>
            <div class="form-group">
              <label>{{ bikText }}</label>
              <input type="text" formControlName="bik" class="form-control" />
            </div>
          </div>
        </div>

        <div class="form-section">
          <h3>{{ bankAccountsText }}</h3>
          <div formArrayName="bankAccounts">
            <div *ngFor="let account of bankAccounts.controls; let i = index" [formGroupName]="i" class="form-row account-row">
              <div class="form-group">
                <label>{{ currencyText }}</label>
                <select formControlName="currency" class="form-control">
                  <option value="">{{ selectCurrencyText }}</option>
                  <option value="KZT">KZT</option>
                  <option value="USD">USD</option>
                  <option value="EUR">EUR</option>
                  <option value="CNY">CNY</option>
                  <option value="RUB">RUB</option>
                </select>
              </div>
              <div class="form-group">
                <label>{{ accountNumberText }}</label>
                <input type="text" formControlName="account" class="form-control" />
              </div>
              <button *ngIf="bankAccounts.length > 1" type="button" (click)="removeBankAccount(i)" class="btn btn--link-danger">
                {{ removeAccountText }}
              </button>
            </div>
          </div>
          <button type="button" (click)="addBankAccount()" class="btn btn--ghost">+ {{ addAccountText }}</button>
        </div>

        <div class="form-section">
          <h3>{{ contractSignerText }}</h3>
          <div class="form-row">
            <div class="form-group">
              <label>{{ signerPositionText }}</label>
              <input type="text" formControlName="contractSignerPosition" class="form-control" />
            </div>
            <div class="form-group">
              <label>{{ signerNameText }}</label>
              <input type="text" formControlName="contractSignerName" class="form-control" />
            </div>
          </div>
        </div>

        <div *ngIf="requisitesError" class="error-message">{{ requisitesError }}</div>

        <div class="form-actions">
          <button type="button" (click)="cancelEditingRequisites()" class="btn btn--ghost">{{ cancelText }}</button>
          <button type="submit" [disabled]="savingRequisites" class="btn btn--primary">{{ savingRequisites ? savingText : saveText }}</button>
        </div>
      </form>
    </section>
  </div>

  <!-- Подтверждение удаления аккаунта -->
  <div *ngIf="showDeleteModal" class="modal-overlay" (click)="closeDeleteModal()">
    <div class="modal" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
      <h2>{{ deleteAccountTitle }}</h2>
      <p class="modal__warning">{{ deleteAccountWarning }}</p>
      <label class="modal__label">{{ deleteAccountConfirmLabel }}</label>
      <input type="text" class="form-control" [(ngModel)]="deleteConfirmText" [placeholder]="deleteAccountConfirmWord" autocomplete="off" />
      <div *ngIf="deleteError" class="error-message">{{ deleteError }}</div>
      <div class="form-actions">
        <button type="button" class="btn btn--ghost" (click)="closeDeleteModal()">{{ deleteAccountCancelText }}</button>
        <button type="button" class="btn btn--danger-solid" [disabled]="!canConfirmDelete || deletingAccount" (click)="confirmDeleteAccount()">
          {{ deleteAccountConfirmButtonText }}
        </button>
      </div>
    </div>
  </div>
</div>
